























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { GET_PROJECT } from './getProject';
import ProjectForm from '@/components/Project/ProjectForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_updateProject } from '../../queries/__generated__/updateProject';
import gql from 'graphql-tag';

const UPDATE_PROJECT = gql`
  mutation updateProject(
    $id: ID!,
    $code: String,
    $name: String,
  ) {
    updateProject(
      input: {
        project: {
          id: $id,
          code: $code,
          name: $name,
        }
      }
    ) {
      project {
        id
        code
        name
      }
    },
  },
`;

@Component({
  components: {
    ProjectForm,
  },
})
export default class ProjectEdit extends Vue {
  @Prop([ Number, String ]) public id!: number | string;

  public GET_PROJECT = GET_PROJECT;
  public UPDATE_PROJECT = UPDATE_PROJECT;

  @Emit()
  public projectUpdated(store: InMemoryCache, query: { data: GQL_updateProject }) {
    return query.data.updateProject && query.data.updateProject.project;
  }
}
